const menuOpened = new Event('menu-opened');

// Document click listener
document.addEventListener('click', (event) => {
    // // Toggle Menu Button
    // if (event.target.matches('.js-menu-toggle')) {
    //     document.body.classList.toggle('menu-open');
    //     if (document.body.classList.contains('menu-open')) {
    //         document.dispatchEvent(menuOpened);
    //     }
    //     // close search widget and mini cart widget if they are open
    //     document.body.classList.remove('product-search-active');
    //     document.body.classList.remove('mini-cart-active');
    // }
});
document.addEventListener('DOMContentLoaded', () => {

    // Dropdown Language Switcher
    const ls = document.querySelector('.js-dropdown-language-switcher');
    if (ls) {
        const lsToggle = ls.querySelector('.js-language-switcher-toggle');
        lsToggle.addEventListener('click', () => {
            ls.classList.toggle('active');
        });
    }
});